import ProjectDashboard from '../Dashboard/Dashboard';
import ProjectReports from '../ProjectReports';
import Settings from '../Settings/Settings';

export const TAG_FILE_WORKSTREAM_LABEL = 'Add/Edit Tagged Workstream';
export const EMAIL_SUFFIX = process.env.INBOX_DOMAIN || 'app.cloudcfo.ph';
export const FALLBACK_EMAIL = 'N/A';

export const PROJECT_PAGE_ROUTES = {
  project_dashboard: {
    path: '/projects/:projectId',
    exact: true,
    component: ProjectDashboard,
  },
  reports: {
    path: '/projects/:projectId/reports',
    exact: true,
    component: ProjectReports,
  },
  project_settings: {
    path: '/projects/:projectId/settings/:settingsRoute',
    exact: true,
    component: Settings,
  },
};
